import styled from 'styled-components';

export const StyledDottedLine = styled.div`
  display: inline-block;
  border: none;
  border-top: 2px dashed #f88d2b;
  width: 20px;
  vertical-align: middle;
`;
